import { render, staticRenderFns } from "./FoxyLoader.vue?vue&type=template&id=3f88f838&scoped=true&"
import script from "./FoxyLoader.vue?vue&type=script&lang=js&"
export * from "./FoxyLoader.vue?vue&type=script&lang=js&"
import style0 from "./FoxyLoader.vue?vue&type=style&index=0&id=3f88f838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88f838",
  null
  
)

export default component.exports